/// <reference lib="dom" />
/** @jsx h */
import { h } from "preact";
import { useEffect } from "preact/hooks";
import * as d3 from "d3";
import { CreateChart } from "../../core/chart.ts";
import { InlineSize, ModeTheme, PadMargin } from "../../core/mode.ts";
import { useChart } from "../../core/useChart.ts";
import { BandLayer } from "../../layers/bands.ts";
import { MarkerLayer } from "../../layers/markers.ts";
import { ChartPalette } from "../../utils/theme.ts";

export const LevelInlineSize = { ...InlineSize, pad: 2 };

function CreateGainChart(container: HTMLElement) {
  const bar = BandLayer();
  const unity = MarkerLayer();
  const chart = CreateChart(container, {
    height: LevelInlineSize.height,
    margin: PadMargin(LevelInlineSize.pad),
    x: d3.scaleLinear().domain([0, 1]),
    y: d3.scaleLinear().domain([0, 1]),
    theme: ModeTheme("inline"),
    layers: [bar, unity],
  });
  return { chart, bar, unity, destroy: chart.destroy };
}

export interface GainBarGraphProps {
  gain: number;
  gainMax: number;
  color?: string;
}

export function GainBarGraph(props: GainBarGraphProps) {
  const { ref, chart } = useChart(CreateGainChart, []);
  const color = props.color ?? ChartPalette.orange;
  useEffect(() => {
    if (!chart) return;
    chart.bar.set([
      { id: "gain", x0: 0, x1: Math.min(props.gain, props.gainMax), color, opacity: 0.4 },
    ]);
    chart.unity.set([{ value: 1, color, opacity: 0.5 }]);
    chart.chart.setDomain([0, props.gainMax]);
  }, [chart, props.gain, props.gainMax, color]);
  return <div ref={ref} />;
}
